import { render, staticRenderFns } from "./tm-order-page.vue?vue&type=template&id=05e4d65a&scoped=true&"
import script from "./tm-order-page.vue?vue&type=script&lang=ts&"
export * from "./tm-order-page.vue?vue&type=script&lang=ts&"
import style0 from "./tm-order-page.vue?vue&type=style&index=0&id=05e4d65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e4d65a",
  null
  
)

export default component.exports